import { Component, Input, OnInit } from '@angular/core';
import { QuizQuestion } from 'src/app/models';

@Component({
  selector: 'app-feedback-page',
  templateUrl: './feedback-page.component.html',
  styleUrls: ['./feedback-page.component.css']
})
export class FeedbackPageComponent implements OnInit {

  // Input variables
  @Input() questions: QuizQuestion[] = [];
  @Input() answers!: number[];
  @Input() correctAnswers!: number[];
  @Input() percentage!: any;
  @Input() moduleNumber!: any;

   // Needed  this to display option letters
   letterArray: String[] = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J'];

  constructor() { }

  ngOnInit(): void {
  }
}
